import WebSocket from 'ws';
import { sendWsMessage } from '../../connection/create-ws-bridge.js';
import { resolveFileBrowserSessionParent } from '../resolve-file-browser-session-parent.js';
import type { SessionWorktreeManager } from '../../worktrees/manager.js';
import type { CliE2eeRuntime } from '../../lib/e2ee/index.js';
import { handleFileBrowserList } from './handle-file-browser-list.js';
import { handleFileBrowserRead } from './handle-file-browser-read.js';
import { resolveGitBranchScope } from './resolve-git-branch-scope.js';
import { beginFileBrowserRequest, endFileBrowserRequest } from './in-flight.js';
import type { FileBrowserRequestMessage } from './types.js';

export type { FileBrowserRequestMessage, FileBrowserSource } from './types.js';

/**
 * Handles list/read asynchronously so directory and file work can yield and the bridge
 * WebSocket stays responsive.
 */
export function handleFileBrowserRequest(
  msg: FileBrowserRequestMessage,
  socket: WebSocket,
  e2ee?: CliE2eeRuntime,
  sessionWorktreeManager?: SessionWorktreeManager,
): void {
  beginFileBrowserRequest();
  void (async () => {
    try {
      const reqPath = msg.path.replace(/^\/+/, '') || '.';
      const sessionParentPath =
        sessionWorktreeManager != null
          ? await resolveFileBrowserSessionParent(sessionWorktreeManager, msg.sessionId)
          : undefined;

      const gitScope = resolveGitBranchScope(msg);
      if (
        msg.source === 'git_branch' &&
        typeof msg.repoRelPath === 'string' &&
        typeof msg.branch === 'string' &&
        msg.branch.trim().length > 0 &&
        !gitScope
      ) {
        sendWsMessage(socket, { type: 'file_browser_response', id: msg.id, error: 'Invalid repository path' });
        return;
      }

      if (msg.op === 'read') {
        await handleFileBrowserRead(socket, e2ee, msg, reqPath, sessionParentPath, gitScope);
      } else {
        await handleFileBrowserList(socket, e2ee, msg.id, reqPath, sessionParentPath, gitScope);
      }
    } finally {
      endFileBrowserRequest();
    }
  })();
}
